import { useState, useEffect, useCallback } from 'react';
import { SECTION_IDS } from '../PageSections/PageSections';
import styles from './HamburgerMenu.module.css';

const MENU_ITEMS = [
  { id: 'events-top', title: 'Events' },
  { id: SECTION_IDS.WHO_ARE_WE, title: 'Who Are We' },
  { id: SECTION_IDS.SOUND_SYSTEM, title: 'Sound System' },
  { id: SECTION_IDS.VENUE_FEATURES, title: 'Venue Features' },
  { id: SECTION_IDS.HOUSE_RULES, title: 'House Rules' },
];

export function HamburgerMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const [glitchId, setGlitchId] = useState<string | null>(null);

  const toggleMenu = useCallback(() => {
    setIsOpen((prev) => !prev);
    setGlitchId(null);
  }, []);

  const scrollToSection = useCallback((sectionId: string) => {
    setGlitchId(sectionId);
    // Wait for glitch animation to play, then close and scroll
    setTimeout(() => {
      setIsOpen(false);
      setGlitchId(null);
      setTimeout(() => {
        if (sectionId === 'events-top') {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          const el = document.getElementById(sectionId);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      }, 100);
    }, 250);
  }, []);

  // Lock body scroll when menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  // Close on Escape key
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        setIsOpen(false);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen]);

  return (
    <>
      <button
        className={`${styles.hamburgerButton} ${isOpen ? styles.open : ''}`}
        onClick={toggleMenu}
        aria-label={isOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={isOpen}
      >
        <span />
        <span />
        <span />
      </button>

      <div className={`${styles.overlay} ${isOpen ? styles.open : ''}`}>
        <div className={styles.menuContent}>
          <nav className={styles.menuNav}>
            {MENU_ITEMS.map((item) => (
              <button
                key={item.id}
                className={`${styles.menuItem} ${glitchId === item.id ? styles.glitch : ''}`}
                onClick={() => scrollToSection(item.id)}
              >
                {item.title}
              </button>
            ))}
            <a
              className={styles.menuItem}
              href="/audio-showroom/"
              onClick={() => setIsOpen(false)}
            >
              Audio Showroom &amp; Gear
            </a>
          </nav>
        </div>
      </div>
    </>
  );
}
